import * as Yup from 'yup'

export const initialFormValues = (values) => {
    values = values || {}
    // values.exportSettings = values.exportSettings || {}
    return {
        productExport: values.product_export || "TITLE",
        customerExport: values.customer_export ?? 1,
        exportSettings: {
            automatic: values.export_settings_automatic ? true : false,
            notifications: values.export_settings_notifications ? true : false
        },
        createSale: values.create_sale ? true : false,
        createDeposit: values.create_deposit ? true : false,
        createItem: values.create_item ? true : false,
        updateStock: values.update_stock ? true : false,
    }
}

export const formValidationSchema = Yup.object({
    // brand_multiplier: Yup.string().required('This field is required'),
    // category_multiplier: Yup.string().required('This field is required'),
    // product_multiplier: Yup.string().required('This field is required'),
    // credit_card_fee: Yup.string().required('This field is required'),
})
